'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFormState = exports.submitConsentResponses = exports.resetEventDateTime = exports.setEventDateTime = undefined;
exports.setEventDate = setEventDate;
exports.resetEventDate = resetEventDate;
exports.setEventDuration = setEventDuration;
exports.setGivenConsent = setGivenConsent;
exports.resetConsentResponses = resetConsentResponses;
exports.setTimezone = setTimezone;
exports.setFormValue = setFormValue;
exports.resetFormState = resetFormState;

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _AutoSubmitSelector = require('MeetingsLib/selectors/AutoSubmitSelector');

var _BookActions = require('./BookActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setEventDate(dateString) {
  return {
    type: _ActionTypes2.default.SET_EVENT_DATE,
    date: dateString
  };
}

function resetEventDate() {
  return {
    type: _ActionTypes2.default.SET_EVENT_DATE,
    date: null
  };
}

var setEventDateTime = exports.setEventDateTime = function setEventDateTime(millisDateTime) {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes2.default.SET_EVENT_DATE_TIME,
      dateTime: millisDateTime
    });

    if ((0, _AutoSubmitSelector.canSubmitBooking)(getState())) {
      dispatch((0, _BookActions.bookMeeting)());
    }
  };
};

var resetEventDateTime = exports.resetEventDateTime = function resetEventDateTime() {
  return {
    type: _ActionTypes2.default.SET_EVENT_DATE_TIME,
    dateTime: null
  };
};

function setEventDuration(duration) {
  return {
    type: _ActionTypes2.default.SET_EVENT_DURATION,
    duration: duration
  };
}

function setGivenConsent(checkbox, checked) {
  return {
    type: _ActionTypes2.default.SET_GIVEN_CONSENT,
    communicationTypeId: checkbox.communicationTypeId,
    consented: checked
  };
}

var submitConsentResponses = exports.submitConsentResponses = function submitConsentResponses(stagedLegalConsentResponses) {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes2.default.SET_CONSENT_RESPONSES,
      payload: stagedLegalConsentResponses
    });

    if ((0, _AutoSubmitSelector.canSubmitBooking)(getState())) {
      dispatch((0, _BookActions.bookMeeting)());
    }
  };
};

function resetConsentResponses() {
  return {
    type: _ActionTypes2.default.RESET_CONSENT_RESPONSES
  };
}

function setTimezone(timezone) {
  return {
    type: _ActionTypes2.default.SET_TIMEZONE,
    timezone: timezone
  };
}

function setFormValue(formFieldName, formFieldValue) {
  return {
    type: _ActionTypes2.default.SET_FORM_FIELD,
    payload: {
      fieldName: formFieldName,
      fieldValue: formFieldValue
    }
  };
}

function resetFormState() {
  return {
    type: _ActionTypes2.default.RESET_FORM_STATE
  };
}

var setFormState = exports.setFormState = function setFormState(stagedFormState) {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes2.default.SET_FORM_STATE,
      payload: stagedFormState
    });

    if ((0, _AutoSubmitSelector.canSubmitBooking)(getState())) {
      dispatch((0, _BookActions.bookMeeting)());
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/actions/FormActions.js
// module id = 26
// module chunks = 0